"use client";

import React from "react";
import { Badge } from "../../badge.js";
import { UserCheck, User, UserX, Clock } from "lucide-react";

interface AttendeeStatusBadgeProps {
  status?: string;
  showIcon?: boolean;
  size?: "sm" | "md";
  className?: string;
}

export function AttendeeStatusBadge({ 
  status, 
  showIcon = false, 
  size = "sm",
  className = "" 
}: AttendeeStatusBadgeProps) {
  const normalizedStatus = status?.toLowerCase();

  const getStatusConfig = (status: string) => {
    switch (status) {
      case "accepted":
        return {
          variant: "secondary" as const,
          className: "bg-slate-100 text-slate-800 border-gray-200",
          text: "Accepted",
          icon: UserCheck
        };
      case "declined":
        return {
          variant: "secondary" as const,
          className: "bg-slate-100 text-slate-800 border-gray-200",
          text: "Declined", 
          icon: UserX
        };
      case "tentative":
        return {
          variant: "secondary" as const,
          className: "bg-slate-100 text-slate-800 border-gray-200",
          text: "Tentative",
          icon: Clock
        };
      case "needsaction":
      case "needs_action":
        return {
          variant: "secondary" as const,
          className: "bg-slate-100 text-slate-800 border-gray-200",
          text: "No Response",
          icon: User
        };
      default:
        return {
          variant: "secondary" as const,
          className: "bg-slate-100 text-slate-800 border-gray-200",
          text: "Unknown",
          icon: User
        };
    }
  };

  const config = getStatusConfig(normalizedStatus || "");
  const Icon = config.icon;
  const sizeClasses = size === "sm" ? "text-xs px-2 py-1" : "text-sm px-3 py-1.5";

  return (
    <Badge 
      variant={config.variant}
      className={`${config.className} ${sizeClasses} ${className} flex items-center gap-1`}
    >
      {showIcon && <Icon className="h-3 w-3" />}
      {config.text}
    </Badge>
  );
}
